// extracted by mini-css-extract-plugin
module.exports = {"locationsList":"locationsList-module--locations-list--3yEA0","listSmall":"locationsList-module--list-small--d7SMd","listLarge":"locationsList-module--list-large--2qsgt"};